<template>
  <div class="user" ref="userRef" style="height: 100%;">
    <Header
      v-if="$route.query.platform !== 'mini'"
      ref="navBarRef"
      title="个人中心"
      backgroundColor="#874DD5"
      titleColor="#FFFFFF"
    >
    </Header>
    <div class="content" ref="contentRef" style="margin-top: -1px">
      <cube-scroll ref="scrollRef" :options="scrollOptions" @pulling-down="onPullingDown" >
        <div class="user-info" @click="gotoPage('/user/userInfo', '/pages/user/info/info')" >
          <div class="my-name-head">
            <img v-if="user.avatar" :src="user.avatar" class="my-head"/>
            <div v-else class="my-head"
                 style="background-color: #ffffff; color: #874DD5; font-size: 22px;
                        display: flex; align-items: center; justify-content: center; font-weight: 500;">
            </div>
            <span class="my-name">{{user.name}}</span>
          </div>
          <img class="arrow" src="@/assets/images/icons/icon-ce-arrow.png"/>
        </div>
        <div class="bar" @click="gotoPage('/user/myIntegral', '/pages/user/integral/integral')">
          <span class="bar-name">我的积分</span>
          <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png"/>
        </div>
        <router-link v-if="$route.query.platform !== 'mini'" class="bar" to="/user/update">
          <span class="bar-name">版本更新</span>
          <img class="arrow" src="@/assets/images/icons/icon-arrow-right.png"/>
        </router-link>
        <div class="logout" @click="logoutClick">
          退出登录
        </div>
      </cube-scroll>
    </div>
    <router-view />
  </div>
</template>
<script>
import Header from '@/components/Header'
import { queryUserDetail, logout } from '@/api/user'

export default {
  inject: ['reload'],
  data: function () {
    return {
      scrollOptions: {
        pullDownRefresh: {
          txt: '刷新成功'
        }
      },
      user: {
        id: '',
        name: '',
        avatar: ''
      }

    }
  },
  components: {
    Header
  },
  mounted () {
    document.title = '个人中心'

    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.contentRef.style.height = (this.$refs.userRef.clientHeight - navBarHeight) + 'px'
    })

    this.getData()
  },
  watch: {
    '$route' (to, from) {
      if (from.name === 'userInfo') {
        this.getData()
      }
    }
  },
  methods: {
    onPullingDown () {
      // 模拟更新数据
      this.getData()
      setTimeout(() => {
        console.log('更新数据。。。')
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },
    getData () {
      queryUserDetail({}).then((res) => {
        this.user.id = res.data.userId
        this.user.avatar = res.data.avatar
        this.user.name = res.data.name
      })
    },
    logoutClick () {
      console.log('logout  ' + logout)
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.redirectTo({ url: '/pages/index/index' })
        wx.miniProgram.postMessage({ data: 'logout' })
      } else {
        this.$dfzhJsBridge.goLogout()
      }

      // logout({}).then((res)=>{
      //   this.$dfzhJsBridge.goLogout()
      // })
    },

    gotoPage (url, miniUrl) {
      console.log(miniUrl)
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.navigateTo({ url: miniUrl })
      } else {
        this.$router.push({ path: url })
      }
    }
  }

}
</script>
<style lang="stylus" scoped>
.arrow
  width 9px;
  height 15px;
  margin-right 17px
.user-info
  height 94px;
  background-color #874DD5;
  display flex;
  justify-content space-between;
  align-items center
  .my-name-head
    display flex;
    justify-content flex-start;
    align-items center;

    .my-head
      width 64px;
      height 64px;
      margin-left 15px;
      border-radius 50%;
    .my-name
      margin-left 10px;
      font-size:15px;
      color #ffffff
.bar
  margin-top 10px;
  height 49px;
  width 100%;
  display flex;
  justify-content space-between;
  align-items center;
  background-color #ffffff;
  .bar-name
    font-size:15px;
    color #545454;
    margin-left 15px;
.logout
  line-height 49px
  height 49px;
  width 100%;
  font-size:15px;
  color #545454;
  margin-top 10px;
  background-color #ffffff;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
